import { AxiosResponse } from "axios"
import type { HTTPRequestBody } from "../HTTPRequestBody.js"
import HTTPResponse from "../HTTPResponse.js"
import type { HTTPResponseBody } from "../HTTPResponseBody.js"
import HTTPResponseBuilder from "../HTTPResponseBuilder.js"

/**
 * @description
 *	Maps an Axios response to an HTTP response.
 */
const AxiosResponseToHTTPResponse = <O, AI = HTTPRequestBody, AO = HTTPResponseBody>(
	axiosResponse: AxiosResponse<AO, AI>
): HTTPResponse<O> => {
	const builder = new HTTPResponseBuilder<O>()
	for (const [key, value] of Object.entries<unknown>(axiosResponse.headers)) {
		/* eslint-disable-next-line @typescript-eslint/restrict-template-expressions --
		 *	This is OK, because Axios returns values that can be safely
		 *	interpolated as a string. However, another inner HTTP client can
		 *	behave differently.
		 */
		builder.header(key, `${value}`)
	}
	return builder.body(axiosResponse.data).status(axiosResponse.status, axiosResponse.statusText).build()
}

export default AxiosResponseToHTTPResponse
